(function () {
    'use strict';

    angular.module('app').factory('gps.service', ['$rootScope', '$localStorage', '$q', '$interval', '$timeout', '$confirm', '$filter', 'map.factory', 'gpsrover.factory', 'api.factory', function ($rootScope, $localStorage, $q, $interval, $timeout, $confirm, $filter, _map, _gpsrover, _api) {
        // Variables
        var position = null, accuracy = null, accuracyDistance = null, noFixDialog = null, selectedPosition = null;
        

        // Instantiate Geolocation from Open Layers (ol)
        var geolocation = new ol.Geolocation({
            //projection: _map.map.getView().getProjection(),
            trackingOptions: { // https://www.w3.org/TR/geolocation-API/#position_options_interface
                enableHighAccuracy: true
            },
        });
        // Watch position
        geolocation.on('change:position', function () {
            position = new ol.geom.Point(geolocation.getPosition());
        });

        // Watch accuracy
        geolocation.on('change:accuracyGeometry', function () {
            accuracy = geolocation.getAccuracyGeometry();
            accuracyDistance = geolocation.getAccuracy();
        });

        // Instantiate Geolocation from Marxact
        var marxact = {
            intervalPromise: null,
            startTracking: function () {
                if (this.intervalPromise) return;
                this.intervalPromise = $interval(function () {
                    _api.getDeviceLocation().then(function (location) {
                        
                        var locationCoordinates = ol.proj.fromLonLat([location.Longitude, location.Latitude]);
                        var locationDeviation = Math.max(location.LongitudeDeviation, location.LatitudeDeviation);

                        position = new ol.geom.Point(locationCoordinates);
                        //accuracy = new ol.geom.Circle(locationCoords, locationDeviation);
                        accuracy = createAccuracyRing(locationCoordinates, [location.LongitudeDeviation, location.LatitudeDeviation],32);
                        accuracyDistance = locationDeviation;
                    });
                }, 1000);
            },
            stopTracking: function () {
                if (!this.intervalPromise) return;
                $interval.cancel(this.intervalPromise);
                this.intervalPromise = null;
            }
        };

        function createAccuracyRing(coordinates, deviation,n) {
            var ring = [];
            for (var i = 0; i < n; i++)
                ring.push([
                    coordinates[0] + deviation[0] * Math.cos((2 * Math.PI * i) / n),
                    coordinates[1] + deviation[1] * Math.sin((2 * Math.PI * i) / n)
                ]);
            return new ol.geom.Polygon([ring]);
        }

        // Watch position
        $rootScope.$watch(function () { return position; }, function (newValue, oldValue) {
            $rootScope.$broadcast("application:gps:position", position);
        });

        // Watch accuracy
        $rootScope.$watch(function () { return accuracy; }, function (newValue, oldValue) {
            $rootScope.$broadcast("application:gps:accuracy", accuracy);
        });

        // Watch accuracyDistance
        $rootScope.$watch(function () { return accuracyDistance; }, function (newValue, oldValue) {
            $rootScope.$broadcast("application:gps:accuracyDistance", accuracyDistance);
        });

        return {
            initialize: function () {
                geolocation.setProjection(_map.map.getView().getProjection());
                this.connect();
            },
            connect: function () {
                var deferred = $q.defer();
                {
                    // First connecto GPS rover, then Geolocation

                    //if ($rootScope.settings.useGpsRover) {
                    //    _gpsrover.connect().then(function () {

                    //        // Na 15 seconden melding dat er geen fix gevonden is.
                    //        noFixDialog = $timeout(function () {
                    //            $confirm({
                    //                text: $filter('translate')('messages.gpsrovernofix'),
                    //                title: $filter('translate')('messages.gpsrovernofixtitle'),
                    //                ok: $filter('translate')('labels.ok'),
                    //                cancel: $filter('translate')('labels.cancel')
                    //            }, { backdrop: 'static' }).then(function () {
                    //                _gpsrover.disconnect();
                    //                geoloc();
                    //                deferred.reject();
                    //            });
                    //        }, 15000);

                    //        $rootScope.$on("application:gpsrover:gpsFixReceived", function (event, args) {
                    //            // Cancel timeout
                    //            if (!_.isUndefined(noFixDialog))
                    //                $timeout.cancel(noFixDialog);
                    //            // Apply position and accuracy
                    //            $rootScope.$apply(function () {
                    //                position = args.position;
                    //                accuracy = args.accuracy;
                    //            });
                    //        });
                    //        $rootScope.$on("application:gpsrover:disconnected", function (event) {
                    //            geoloc();
                    //        });
                    //        deferred.resolve();
                    //    }, function () {
                    //        // GPS Rover failed, connect to geolocation
                    //        geoloc();
                    //        // Reject
                    //        deferred.reject();
                    //    });
                    //}
                }
                if ($localStorage.marxact && $localStorage.marxact.enable && $localStorage.marxact.token) {
                    geolocation.setTracking(false);
                    marxact.startTracking();
                }
                else {
                    geolocation.setTracking(true);
                    marxact.stopTracking();
                }
                return deferred.promise;
            },
            disconnect: function () {
                geolocation.setTracking(false);
                marxact.stopTracking();

                if (!_.isUndefined(noFixDialog))
                    $timeout.cancel(noFixDialog);
                _gpsrover.disconnect();
            },
            reconnect: function () {
                this.disconnect();
                this.connect();
            },
            position: function () {
                if (!_.isNull(position))
                    return position.getCoordinates();
                return null;
            },
            accuracy: function () {
                if (!_.isNull(accuracyDistance))
                    return accuracyDistance;
                return null;
            },
            getSelectedPosition: function () {
                return selectedPosition;
            },
            setSelectedPosition: function (coordinates) {
                selectedPosition = coordinates;
                $rootScope.$broadcast("application:gps:selectedPosition", selectedPosition)
            }
        }

    }]);
})();